import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core'
import { MatIcon } from '@angular/material/icon'
import { EntityRef } from 'src/app/shared/models/referenceData'
import { SelectMenuSearchComponent } from '../table/filters/select-menu-search/select-menu-search.component'
import { FilterSearchMeta, FilterSearchState } from 'src/app/shared/utilities/filter-search-state'
import { Subscription } from 'rxjs'
import { ReferenceDataService } from '../reference-data/reference-data.service'
import { SelectMenuListComponent } from '../table/filters/select-menu-list/select-menu-list.component'
import { SelectMenuListItemComponent } from '../table/filters/select-menu-list-item/select-menu-list-item.component'
import {
  SelectMenuListloadingComponent,
} from '../table/filters/select-menu-list-loading-item/select-menu-list-loading-item.component'
import {
  SelectMenuListErrorComponent,
} from '../table/filters/select-menu-list-error-item/select-menu-list-error-item.component'
import {
  SelectMenuListNoItemsComponent,
} from '../table/filters/select-menu-list-no-items-item/select-menu-list-no-items-item.component'
import {
  SelectMenuListPagingComponent,
} from '../table/filters/select-menu-list-paging-item/select-menu-list-paging-item.component'
import {
  SelectMenuListDividerComponent,
} from '../table/filters/select-menu-list-divider-item/select-menu-list-divider-item.component'
import {
  SelectMenuListNamedSectionComponent,
} from '../table/filters/select-menu-list-named-section-item/select-menu-list-named-section-item.component'
import { EntityFilterConfig } from 'src/app/shared/services/filter/entity-filter'

@Component({
  imports: [
    MatIcon,
    SelectMenuSearchComponent,
    SelectMenuListComponent,
    SelectMenuListItemComponent,
    SelectMenuListNamedSectionComponent,
    SelectMenuListDividerComponent,
    SelectMenuListloadingComponent,
    SelectMenuListNoItemsComponent,
    SelectMenuListPagingComponent,
    SelectMenuListErrorComponent,
  ],
  selector: 'div[app-entity-selector]',
  template: `
    <div class="wrapper" [class.slim]="slim">
      <mat-icon
        class="search-icon"
        [class.disabled]="disabled"
        svgIcon="search"
        (click)="toggle()"
      ></mat-icon>
      <input
        type="button"
        [placeholder]="'none'"
        [value]="displayText"
        [disabled]="disabled"
        (click)="toggle()"
      />
      <div class="popover" [class.open]="open">
        <div
          app-select-menu-search
          name="entity_code"
          [label]="label"
          [value]="searchMeta?.searchTerm ?? ''"
          (search)="searchState.search($event)"
        ></div>
        <ul app-select-menu-list (scroll)="onScroll($event)">
          @if(config.allowWildcards) {
          
          @if(searchMeta?.searchTerm) {
          <li
            app-select-menu-list-item
            [label]="'Current Search'"
            [value]="searchMeta?.searchTerm ?? ''"
            [display]="searchMeta?.searchTerm ?? ''"
            [selected]="selectedWildcards.includes(searchMeta?.searchTerm ?? '')"
            [multi]="true"
            (select)="setWildcardValue($event)"
          ></li>
          }

          @for(result of selectedWildcards; track result; let first = $first,
          last = $last) { @if(first) {
          <li app-select-menu-list-named-section-item name="Selected Wildcards"></li>
          }
          <li
            app-select-menu-list-item
            [value]="result"
            [display]="result"
            [selected]="true"
            [multi]="true"
            (select)="setWildcardValue($event)"
          ></li>
          @if(last) {
          <li app-select-menu-list-divider-item></li>
          } } }

          @for(result of selectedEntitiesMap; track result[0]; let first = $first,
          last = $last) { @if(first) {
          <li app-select-menu-list-named-section-item name="Selected"></li>
          }
          <li
            app-select-menu-list-item
            [value]="result[1]"
            [label]="result[1].entity_code"
            [display]="result[1].entity_name"
            [selected]="true"
            [multi]="!!config.allowMultiple"
            (select)="setValue($event)"
          ></li>
          @if(last) {
          <li app-select-menu-list-divider-item></li>
          } }

          @if(searchMeta?.searching) {
          <li app-select-menu-list-loading-item></li>
          }

          @else if(searchMeta?.error ) {
          <li app-select-menu-list-error-item></li>
          }

          @else {
          @for (result of searchResults; track result.entity_code;) {
          <li
            app-select-menu-list-item
            [value]="result"
            [label]="result.entity_code"
            [display]="result.entity_name"
            [selected]="
              selectedEntitiesMap
                ? selectedEntitiesMap.has(result.entity_code)
                : result.entity_code === value?.entity_code
            "
            [multi]="!!config.allowMultiple"
            (select)="setValue($event)"
          ></li>
          }

          <!-- SHOW NO RESULTS -->
          @if(!searchResults.length) {
          <li app-select-menu-list-no-items-item></li>
          }

          <!-- SHOW PAGING -->
          @if(searchMeta?.paging ) {
          <li app-select-menu-list-paging-item></li>
          } }
        </ul>
      </div>
    </div>
  `,
  styles: `
    .wrapper {
      position: relative;
      width: 100%;
      padding: 0.5rem 0.75rem;
      border: 1px solid black;

      &.slim {
        padding: 0.5rem 0 0;
        border: none; 
      }
    }

    input {
      width: 100%;
      padding: 0.5rem 1.75rem 0.25rem 0.25rem;
      border: none;
      background: white;
      text-align: left;
      border-bottom: 1px solid black;
      font-size: 0.9rem;
      line-height: 1.25rem;

      &:focus {
        outline: none;
      }
    }

    .search-icon {
      position: absolute;
      top: 0.75rem;
      right: 0.25rem;

      &.disabled {
        opacity: 0.5;
      }
    }
  
    .popover {
      display: none;
      position: absolute;
    }

    .popover.open {
      z-index: 3;
      display: flex;
      flex-direction: column;
      min-height: 7rem;
      width: 300px;
      right: 0;
      top: calc(100% + 0.5rem);
      border: 1px solid black;
      border-radius: 0;
      padding: 0.5rem 1rem;
      background: white;


      &::before {
        content: ' ';
        border: none;
        border-top: 1px solid black;
        border-right: 1px solid black;
        width: 0.5rem;
        height: 0.5rem;
        transform: rotate(-45deg);
        position: absolute;
        top: calc(-0.25rem - 1px);
        background: linear-gradient(
          45deg, 
          rgba(255,255,255,0) 0%, 
          rgba(255,255,255,0) calc(50% - 1px), 
          rgba(255,255,255,1) calc(50% - 1px), 
          rgba(255,255,255,1) 100%
          );
        right: 1rem;
      }
    }
  `,
})
export class EntitySelectorComponent implements OnInit, OnDestroy {
  elementRef = inject(ElementRef)
  referenceDataService = inject(ReferenceDataService)

  @Input() value: EntityRef | null | undefined = null
  @Input() label = ''
  @Input() config: EntityFilterConfig
  @Input() slim = false
  @Input() disabled = false

  public selectedEntitiesMap: Map<string, EntityRef> | undefined 
  @Input() set selectedEntities(val: Map<string, EntityRef> | readonly EntityRef[] | undefined) {
    if (!val) {
      this.selectedEntitiesMap = undefined
    } else if (Array.isArray(val)) {
      this.selectedEntitiesMap = new Map(val.map((v) => [v.entity_code, v]))
    } else {
      this.selectedEntitiesMap = val as Map<string, EntityRef>
    }
  }

  @Input() selectedWildcards: readonly string[] = []

  @Output() valueChange = new EventEmitter<EntityRef>()
  @Output() wildcardValueChange = new EventEmitter<string>()

  open = false
  subscription = new Subscription()
  searchResults: EntityRef[] = []
  searchMeta?: FilterSearchMeta
  searchState: FilterSearchState<EntityRef>

  get displayText() {
    if (this.selectedEntitiesMap || this.selectedWildcards.length) {
      const selectedCount = (this.selectedEntitiesMap?.size ?? 0) + this.selectedWildcards.length
      if (selectedCount === 0) {
        return 'None Selected'
      }
      return selectedCount > 1
        ? `${selectedCount} Selected`
        : [
          ...[...(this.selectedEntitiesMap?.values() ?? [])].map(v => v.entity_name), 
          ...this.selectedWildcards][0]
    }
    return this.value?.entity_name ?? 'None Selected'
  }

  @HostListener('document:click', ['$event'])
  handleOutsideClick(event: Event) {
    if (
      this.open &&
      !this.elementRef.nativeElement.contains(event.target as Node)
    ) {
      this.toggle()
    }
  }

  ngOnInit(): void {
    this.config = {
      resource: this.config.resource,
      allowMultiple: this.config.allowMultiple ?? true,
      allowWildcards: this.config.allowWildcards ?? false,
    }
    this.searchState = new FilterSearchState<EntityRef>(
      ((searchTerm: string) => {
        return this.referenceDataService.data(this.config.resource!, searchTerm)
      }),
    )
    this.subscription.add(
      this.searchState.results$.subscribe((r) => {
        this.searchResults = r.filter(
          (r) =>
            !(this.selectedEntitiesMap?.has(r.entity_code)),
        )
      }),
    )
    this.subscription.add(
      this.searchState.meta$.subscribe((m) => {
        this.searchMeta = m
      }),
    )
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe()
  }

  toggle(): void {
    this.open = !this.open
    this.searchState.search('')
  }

  onScroll(evt: Event) {
    const { scrollHeight, scrollTop, clientHeight } = evt.target as Element
    const threshold = 15
    const reachedThreshold =
      Math.abs(scrollHeight - clientHeight - scrollTop) < threshold
    if (
      this.searchMeta?.hasMore &&
      reachedThreshold &&
      !this.searchMeta.paging &&
      !this.searchMeta.searching
    ) {
      this.searchState.page()
    }
  }

  setValue(event: EntityRef) {
    this.value = event
    this.valueChange.emit(event)
    if (!this.config.allowMultiple) {
      this.open = false
    }
  }

  setWildcardValue(event: string) {
    this.wildcardValueChange.emit(event)
    if (!this.config.allowMultiple) {
      this.open = false
    }
  }
}
